import React from "react";
import dmarcFlowLogo from './assets/img/dmarc-flow-logo.png';
import germany from './assets/img/germany.svg';
import usa from './assets/img/usa.svg';
import {Container} from "react-bootstrap";
import Navbar from 'react-bootstrap/Navbar';
import {useTranslation} from "react-i18next";

const TopMenu = ({setActiveMenu}) => {
    const {t, i18n} = useTranslation();
    const changeLanguageHandler = (lang) =>
    {
        i18n.changeLanguage(lang)
    }

    return (
        <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
            <Container className={"d-flex justify-content-evenly"}>
                <Navbar.Brand href={"/"}>
                    <img
                        alt="DMARC Flow Logo"
                        src={dmarcFlowLogo}
                        width="60"
                        height="60"
                        className="d-inline-block align-top"
                    />
                </Navbar.Brand>
                <Container className={"d-flex justify-content-end"}>
                    <img
                        alt="DMARC Flow Logo"
                        src={germany}
                        width="30"
                        height="15"
                        className="d-inline-block align-top clickable img-fluid rounded shadow me-2"
                        onClick={() => changeLanguageHandler('de')}
                    />
                    <img
                        alt="DMARC Flow Logo"
                        src={usa}
                        width="30"
                        height="15"
                        className="d-inline-block align-top clickable img-fluid rounded shadow"
                        onClick={()=> changeLanguageHandler('en')}
                    />
                </Container>

            </Container>
        </Navbar>
    );
};

export default TopMenu;
